import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top_10_nova_icon_1",
  "use": "icon-top_10_nova_icon_1-usage",
  "viewBox": "0 0 156 336",
  "content": "<symbol viewBox=\"0 0 156 336\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-top_10_nova_icon_1\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M156 0V336H74.3952V95.4211L0 119.258V49.515L137.792 0H156ZM84.2354 81.8617V326.083H146.16V9.91735H139.494L9.84024 56.5079V105.699L84.2354 81.8617Z\" fill=\"#656666\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol